/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierFreeLtiEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_FREE_LTI_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierFreeLtiEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierFreeLtiEnabledSettingParser.decode(input).map(res => new TierFreeLtiEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierFreeLtiEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierFreeLtiEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierFreeLtiEnabledSettingParser.schema();
    }
}
